import { UserModule } from '@/store/modules/user'
import { getRole } from '@/utils/cookies'

// 将工单类型匹配为类型描述
export const formateTicketType = (type: number): string => {
  let desc = ''
  switch (type) {
    case 1:
      desc = '主讲'
      break
    case 2:
      desc = '班主任'
      break
    case 3:
      desc = 'LP(学规)'
      break
    case 4:
      desc = '直播保障工单'
      break
  }
  return desc
}

// 匹配工单问题类型
export const formateTicketIssueType = (issueType: any): string => {
  let desc = ''
  if (typeof issueType !== 'object') return ''
  if (issueType.parent_issue_type && typeof issueType.parent_issue_type === 'object') {
    desc = `${issueType.parent_issue_type.name ? issueType.parent_issue_type.name + '-' + issueType.name : ''}`
  } else {
    desc = issueType.name || ''
  }
  return desc
}

// 匹配工单问题类型
export const formateTicketStatus = (ticketStatus: number, isForward: number): object => {
  const desc = {
    name: '',
    class: ''
  }
  switch (ticketStatus) {
    case 1:
      desc.name = '待受理'
      desc.class = 'orange'
      break
    case 2:
      if (isForward) {
        desc.name = '处理中(转)'
      } else {
        desc.name = '处理中'
      }
      desc.class = 'green'
      break
    case 3:
      desc.name = '已完成'
      desc.class = 'purple'
      break
    case 4:
      desc.name = '已驳回'
      desc.class = 'red'
      break
    case 5:
      desc.name = '已撤销'
      desc.class = 'gray'
      break
    case 6:
      desc.name = '已挂起'
      desc.class = 'orange'
      break
  }
  return desc
}

// 匹配工单是否转接
export const formateIsForward = (isForward: number): string => {
  let desc = ''
  switch (isForward) {
    case 0:
      desc = '未转接'
      break
    case 1:
      desc = '转接个人'
      break
    case 2:
      desc = '转接全员'
      break
  }
  return desc
}

// eslint-disable-next-line @typescript-eslint/interface-name-prefix
export interface ITicketsBtn {
  edit: boolean; // 编辑工单
  hurry: boolean; // 催单
  cancel: boolean; // 撤销
  accept: boolean; // 受理
  reject: boolean; // 拒绝
  forward: boolean; // 转接
  finish: boolean; // 完成
  rate: boolean; // 评价
  close: boolean; // 关闭
  className: string;
  isCompleted: boolean;
  pending: boolean; // 挂起
  unpending: boolean; // 解除挂起
}
/**
 * 设置按钮是否显示 与 按钮样式
 * @ticket 当前的工单项
 * @isCreateCurrentUser 当前用户是否为创建人
 * @isAcceptCurrentUser 当前用户是否为受理人
 * @userType 指定用户类型：1-只创建人，2-只受理人，否则创建人+受理人，显示全部按钮
 * @hasClosebtn 是否有关闭按钮，兼容弹框
 */
export const getBtnClass = (ticket: any, isCreateCurrentUser: boolean, isAcceptCurrentUser: boolean, userType?: number, hasClosebtn?: boolean): ITicketsBtn => {
  const btnStatus: ITicketsBtn = {
    edit: false,
    hurry: false,
    cancel: false,
    accept: false,
    reject: false,
    forward: false,
    finish: false,
    rate: false,
    close: false,
    className: 'fixed-full-btn',
    isCompleted: false,
    pending: false,
    unpending: false
  }
  let count = 0 // 按钮个数
  const hasManagerPermission = (getRole() || 1) > 1 // 是否有受理权限

  if (ticket.status === 1) { // 【待受理】
    if (isCreateCurrentUser && userType !== 2) {
      btnStatus.edit = true // 编辑
      btnStatus.cancel = true // 撤销
      btnStatus.hurry = true // 催单
      count += 3
    }
    if (hasManagerPermission && !isCreateCurrentUser && userType !== 1) {
      btnStatus.accept = true // 受理
      btnStatus.reject = true // 驳回
      count += 2
    }
  } else if (ticket.status === 2) { // 【受理中】
    // origin code
    // if (isCreateCurrentUser && userType !== 2) {
    if (isCreateCurrentUser) {
      btnStatus.hurry = true // 催单
      count += 1
    }
    if (isAcceptCurrentUser && !isCreateCurrentUser && userType !== 1) {
      if (ticket.accept_user.account === UserModule.username) { // 未转接/转给个人-当前受理人为登录用户
        btnStatus.forward = true // 转接
        btnStatus.finish = true // 完成
        btnStatus.reject = true // 驳回
        count += 3
        if (!ticket.pending_time) {
          btnStatus.pending = true // 挂起
          count += 1
        }
      }
    }
  } else if (ticket.status === 3 && (isCreateCurrentUser || (!isCreateCurrentUser && ticket.is_rated))) { // 【已完成】
    if (!ticket.live_ticket_type || (ticket.live_ticket_type && ticket.live_ticket_type === 1)) {
      btnStatus.rate = true // 评价
      count += 1
    }
  } else if (ticket.status === 4 && isCreateCurrentUser) { // 已驳回
    btnStatus.edit = true // 编辑
    count += 1
  } else if (ticket.status === 6 && isAcceptCurrentUser) { // 已挂起
    btnStatus.unpending = true
    if (ticket.app_id === 1) {
      btnStatus.forward = true
      count += 2
    } else {
      count += 1
    }
  } else if (ticket.status === 6 && isCreateCurrentUser) {
    btnStatus.hurry = true // 催单
    count += 1
  }
  if (hasClosebtn) {
    btnStatus.close = true // 关闭
    count += 1
  }
  switch (count) {
    case 0:
    case 1:
      btnStatus.className = 'fixed-full-btn'
      break
    case 2:
      btnStatus.className = 'fixed-half-btn'
      break
    case 3:
      btnStatus.className = 'fixed-three-btn'
      break
    case 4:
      btnStatus.className = 'fixed-four-btn'
      break
    case 5:
      btnStatus.className = 'fixed-five-btn'
      break
  }
  return btnStatus
}
